export default function reactInnerHTML(html) {
  return {
    dangerouslySetInnerHTML: { __html: html },
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-inner-html/react-inner-html.es.js
// module id = 55
// module chunks = 0